<template>
	<div ref="tablePage" style="height: 100%">
		<!-- 面包屑导航 -->
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>电销短信/AI电销流程管理</el-breadcrumb-item>
				</el-breadcrumb>
				<el-form ref="queryForm" :model="searchForm" inline label-width="68px" style="margin-left: 6vh">
					<el-form-item style="margin-bottom: 0">
						<el-input v-model="searchForm.name" autocomplete="off" maxlength="30" placeholder="请输入流程名称"
							clearable @input="searchChange" size="small" />
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-select v-model="searchForm.xiaoqu_id" placeholder="请选择小区" clearable
							size="small" filterable @change="xiaoquSearchSelectChange" @clear="searchXiaoquClearInput">
							<el-option v-for="item in regionArr" :key="item.xiaoqu_id" :label="item.xiaoqu_name"
								:value="item.xiaoqu_id" />
						</el-select>
					</el-form-item>
					<!-- <el-form-item style="margin-bottom: 0">
						<el-button icon="el-icon-refresh-left" type="warning" @click="clearSearchInput"
							size="small">重置</el-button>
					</el-form-item> -->
				</el-form>
				<!-- <el-button type="success" icon="el-icon-plus" @click="handleNewAdd" size="mini">新增{{searchForm.type=='flow'?'流程':'短信策略'}}</el-button> -->
			</div>
		</div>
		<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="mini"
			:header-cell-style="{background: '#fff',height: '50px',color: '#909399',fontSize: '16px',fontFamily: 'Arial, sans-serif'}">
			<el-table-column prop="id" label="ID" align="center" />
			<el-table-column prop="name" label="名称" align="center" />
			<el-table-column prop="script_url" label="音频" align="center" width="360">
				<template slot-scope="scope">
					<audio v-if="scope.row.script_url" controls :src="scope.row.script_url"></audio><br>
					<a :href="scope.row.script_url" target="_blank" style="color: #409eff">{{scope.row.script_url}}</a>
				</template>
			</el-table-column>
			<el-table-column prop="script_content" label="内容" align="center" />
			<!-- <el-table-column prop="" label="短信策略" align="center" >
				<template slot-scope="scope">
					<div v-for="(item,index) in scope.row.sms_strategys" :key="index" style="display: flex;flex-direction: column;">
						<div>名称：{{item.strategy_name}}</div>
						<div>内容：{{item.script_content}}</div>
					</div>
				</template>
			</el-table-column> -->
			<el-table-column prop="bind_xiaoqu" label="小区" align="center" >
				<template slot-scope="scope">
					<div v-if="" v-for="(item,index) in scope.row.bind_xiaoqu.split(',')" :key="index">
						{{findXiaoqu(item)}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="send_day" label="发送日期" align="center" />
			<el-table-column prop="send_time" label="发送时间" align="center" />
			<el-table-column fixed="right" label="操作" align="center">
				<template slot-scope="scope">
					<el-button @click.native.prevent="handleClick(scope.row)" type="primary" size="small"
						icon="el-icon-edit">
						修改
					</el-button>
					<!-- <el-button @click.native.prevent="singleDel(scope.row, scope.row.id)" type="danger" size="small"
						icon="el-icon-delete">
						移除
					</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pageSize"
			@pagination="initList" />
		<el-dialog :title="title" :visible.sync="addOrEditOpen" :close-on-click-modal="false" width="45%"
			class="dialogHeight2 global-dialog-position" :before-close="getout" :lock-scroll="false"
			:append-to-body="true" style="margin-top: -10vh">
			<el-form ref="form" :model="form" label-width="108px" :rules="rules">
				<el-row>
					<el-form-item label="选择小区" prop="bind_xiaoqu">
						<el-select v-model="form.bind_xiaoqu" style="width: 100%;" placeholder="请选择小区" clearable multiple
							size="small" filterable @change="xiaoquSelectChange">
							<el-option v-for="item in regionArr" :key="item.xiaoqu_id" :label="item.xiaoqu_name"
								:value="item.xiaoqu_id" />
						</el-select>
					</el-form-item>
					<el-col :span="24">
						<el-form-item label="流程名称" prop="name">
							<el-input v-model="form.name" disabled autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="话术语音" prop="script_url">
							<audio v-if="form.script_url" controls :src="form.script_url"></audio>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="话术内容" prop="script_content">
							<el-input v-model="form.script_content" disabled type="textarea" autocomplete="off"
								placeholder="请输入" rows="6" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="发送日期" prop="send_day">
							<el-date-picker v-model="form.send_day" format="yyyy年MM月dd日" value-format="yyyy-MM-dd"
								type="date" align="right" style="width: 100%" @input="changeDate">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="发送时间" prop="send_time">
							<el-time-picker v-model="form.send_time" format="HH:mm"
								value-format="HH:mm"></el-time-picker>
						</el-form-item>
					</el-col>
					<!-- <block v-for="(item,index) in form.sms_strategys" :key="index">
						<el-col :span="24">
							<el-form-item label="短信策略" prop="sms_strategys">
								<el-input v-model="form.strategy_name" disabled type="textarea" autocomplete="off"
									placeholder="请输入" />
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="短信内容" prop="script_content">
								<el-input v-model="form.script_content" disabled type="textarea" autocomplete="off"
									placeholder="请输入" />
							</el-form-item>
						</el-col>
					</block> -->
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForms">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import tableCommon from "../../../mixins/table-common";
	import {
		getFlowSmsList,
		flowSmsAdd,
		flowSmsEdit,
		flowSmsDel,
	} from "../../api/aiCall";
	import {
		deleteImg,
	} from "../../api/homePage";
	import {
		getcarList
	} from "../../api/garage";
	import {
		getCookie
	} from "../../utils/util";

	export default {
		mixins: [tableCommon],
		data() {
			return {
				// 请求地址api
				api: {
					list: getFlowSmsList,
					add: flowSmsAdd,
					edit: flowSmsEdit,
					del: flowSmsDel
				},
				uploadImgUrl: process.env.VUE_APP_URL + "/admin/uploadFile",
				headers: {
					Authorization: "Bearer " + getCookie("logintoken"),
				},
				// 规则验证
				rules: {
					bind_xiaoqu: [{
						required: true,
						message: "请选择小区",
						trigger: "change"
					}],
				},
				// 传参
				form: {},
				regionArr: [],
				// 弹窗标题
				title: "新增",
				addOrEditOpen: false,
				// 查询参数
				searchForm: {
					page: 1,
					pageSize: 15,
					name: '',
					xiaoqu_id: '',
				},
			};
		},
		mounted() {
			const form = {
				select: 1,
			};
			getcarList(form).then((res) => {
				this.regionArr = res.data.records.filter((item, index, self) => {
					return self.findIndex((t) => t.xiaoqu_id === item.xiaoqu_id) === index;
				});
				this.regionArr.forEach((item, index) => item.xiaoqu_id = item.xiaoqu_id.toString());
				console.log(this.regionArr)
				
				
				let jsonArray = JSON.stringify(this.regionArr);
				let jsonArrays = JSON.parse(jsonArray);
				let arr = {
					xiaoqu_id: 0,
					xiaoqu_name: "通用",
				};
				jsonArrays.unshift(arr);
				this.regionArr = jsonArrays;
			});
		},
		methods: {
			searchXiaoquClearInput() {
				this.searchForm.xiaoqu_id = '';
				this.searchChange();
			},
			xiaoquSearchSelectChange() {
				this.searchChange();
			},
			clearSearchInput() {
				this.searchForm.name = '';
				this.searchForm.xiaoqu_id = '';
				this.searchChange();
			},
			xiaoquSelectChange(data) {
				this.$forceUpdate();
			},
			changeDate(e) {
				this.$forceUpdate();
			},
			// addClearXiaoquInput() {
			// 	this.form.xiaoqu_id = '';
			// },
			// 重置
			reset() {
				this.form = {};
			},
			// 新增弹窗
			handleNewAdd() {
				this.title = "新增";
				this.reset();
				this.handleAdd();
				this.$nextTick(() => {
					this.$refs.form.clearValidate();
				});
			},
			// 修改弹窗
			handleClick(row) {
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row));
				this.form.bind_xiaoqu = this.form.bind_xiaoqu ? this.form.bind_xiaoqu.split(',') : null;
				console.log('行修改点击：', this.form);

				this.handleEdit();
			},
			// 点击确定
			submitForms() {
				console.log('===================form:', this.form)
				try {
					// 提交表单
					if (this.form.bind_xiaoqu.length) {
						this.form.bind_xiaoqu = this.form.bind_xiaoqu.join(',');
					}
					this.submitForm(this.form);
				} catch (error) {
					// 处理提交失败的情况
					this.$message.error('提交失败');
					console.error("提交失败:", error);
					// 执行适当的操作，例如显示错误提示信息或进行其他处理
				}
			},
			// 关闭弹窗
			getout() {
				this.addOrEditOpen = false;
				this.$refs.form.clearValidate();
			},
			findXiaoqu(xiaoqu_id) {
				let xiaoqu = this.regionArr.find(item => item.xiaoqu_id.toString() == xiaoqu_id.toString());
				return xiaoqu ? xiaoqu.xiaoqu_name : '';
			},
		},
	};
</script>
<style scoped>
	/deep/.dialogHeight2 .el-dialog__body {
		overflow-y: auto;
	}

	/deep/.dialogHeight .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.dialogHeightX .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	/deep/ .right-aligned-input .el-input__inner {
		text-align: right;
	}

	/deep/ .right-aligned-input .el-input__suffix {
		right: 0;
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}

	.uploadSty .el-upload--picture-card {
		width: 110px;
		height: 110px;
		line-height: 110px;
	}

	/deep/.disUploadSty .el-upload--picture-card {
		display: none;
		/* 上传按钮隐藏 */
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 150px;
		height: 150px;
		line-height: 150px;
		text-align: center;
		border: 1px solid #dcdfe6;
	}

	.avatar {
		width: 150px;
		height: 150px;
		display: block;
	}

	.avatar-wrapper {
		position: relative;
	}

	.el-icon-close {
		position: absolute;
		top: 18px;
		right: 28vh;
		cursor: pointer;
	}

	.el-icon-close:hover {
		color: #409eff;
	}

	.avatar-wrapper .el-icon-close {
		position: absolute;
		top: 5px;
		right: 5px;
		font-size: 18px;
		color: #fff;
		background-color: rgba(0, 0, 0, 0.5);
		padding: 5px;
		border-radius: 50%;
		cursor: pointer;
	}


	/deep/ .el-dialog__body {
		height: 60vh;
	}
</style>


// WEBPACK FOOTER //
// src/views/actAICallSms/aiFlowSms.vue